import { render, staticRenderFns } from "./AsCharts_Block_3.component.vue?vue&type=template&id=7f389f24&scoped=true&"
import script from "./AsCharts_Block_3.component.vue?vue&type=script&lang=js&"
export * from "./AsCharts_Block_3.component.vue?vue&type=script&lang=js&"
import style0 from "./AsCharts_Block_3.component.vue?vue&type=style&index=0&id=7f389f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f389f24",
  null
  
)

export default component.exports